import BaseApi from '@/api/BaseApi';
import type { ILoginRequest, ILoginResponse } from '@/models/AuthModel';
import type { IRegisterRequest } from '@/models/RegisterModel';

export default class AuthApi extends BaseApi {
	async login (params: ILoginRequest) {
		return this.post<ILoginRequest, ILoginResponse>({
			url: '/api/login',
			data: params,
		});
	};

	async register (params: IRegisterRequest) {
		return this.post<IRegisterRequest, string>({
			url: '/api/set-password',
			data: params,
		});
	};
};
